import moment from "moment";
import i18next from "i18next";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import LanguageDetector from "i18next-browser-languagedetector";

import { getPlan, saveExtraClasses } from "../../store/middleware";
import { StudentManagementCss, DivSubscription } from "./styles";

function StudentSubscription({ id, setActiveTab }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [activePlans, setActivePlans] = useState([]);
  const [studentPlans, setStudentPlans] = useState({});
  const [numberClasses, setNumberClasses] = useState("");
  const [contractStudents, setContractStudents] = useState({});
  const [activePlansSelected, setActivePlansSelected] = useState("");

  const currentLanguage = i18next.use(LanguageDetector);

  const getData = () => {
    dispatch(getPlan(id))
      .then((res) => {
        if (res.length === 0) {
          setStudentPlans([]);
          setContractStudents([]);
        } else {
          let student = {
            active: res[0].student.active,
            updatedAt: res[0].student.updatedAt,
            createdAt: res[0].student.createdAt,
            democlass: "-",
            idiomaLevel: res[0].studentPlanLanguages,
            plans: res[0].plan,
          };
          let contractStudents = {};
          if (res[0].student.contractStudents && res[0].student.contractStudents?.length > 0) {
            contractStudents = res[0].student.contractStudents[0];
          }
          setActivePlans(res);
          setStudentPlans(student);
          setContractStudents(contractStudents);
        }
      })
      .catch((err) => console.log("ERRO GET USERS ", err));
  };

  const handleSubmitExtraClasses = async () => {
    const req = {
      count: Number(numberClasses),
      studentPlanId: Number(activePlansSelected),
    };
    await dispatch(saveExtraClasses(req));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <StudentManagementCss>
        <DivSubscription>
          {Object.values(studentPlans).length > 0 && (
            <div className="boxRow">
              <div className="item">
                <div className="boxColumn">
                  <label>{t("STATUS")}</label>
                  <span className={studentPlans?.active ? "active" : "deactive"}>
                    {studentPlans?.active ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>

              <div className="item">
                <div className="boxColumn">
                  <label>{t("STATUS_CHANGE")}</label>
                  <span>{moment(studentPlans?.updatedAt).format("YYYY/MM/DD")}</span>
                </div>
              </div>
              <div className="item">
                <div className="boxColumn">
                  <label>{t("SUBSCRIPTION_DATE")}</label>
                  <span>{moment(studentPlans?.createdAt).utc().format("YYYY/MM/DD")}</span>
                </div>
              </div>
              <div className="item ">
                <div className="boxColumn">
                  <label>{t("DEMO_CLASS")}</label>
                  <span>{studentPlans?.democlass ?? "-"}</span>
                </div>
              </div>
              <div className="item ">
                <div className="boxColumn">
                  <label>{t("LANGUAGE_LEVEL")}</label>
                  <span>
                    {studentPlans &&
                      studentPlans?.idiomaLevel?.map((item, index) => {
                        return index > 0 ? ", " + item.studentLanguageLevel : "" + item.studentLanguageLevel;
                      })}
                  </span>
                </div>
              </div>
            </div>
          )}

          {Object.values(contractStudents).length > 0 && (
            <div className="boxRow">
              <div className="item">
                <div className="boxColumn">
                  <label>B2B</label>
                  <span>{contractStudents?.contract?.active ? t("BTN_YES") : t("BTN_NO")}</span>
                </div>
              </div>

              <div className="item">
                <div className="boxColumn">
                  <label>{t("COMPANY")}</label>
                  <span>{contractStudents?.contract?.company?.socialName}</span>
                </div>
              </div>

              <div className="item">
                <div className="boxColumn">
                  <label>{t("CONTRACT")} #</label>
                  <span>{contractStudents?.id}</span>
                </div>
              </div>

              <div className="item">
                <div className="boxColumn">
                  <label>{t("EXPIRES_ON")}</label>
                  <span>{moment(contractStudents?.contract?.endDate).format("YYYY/MM/DD")}</span>
                </div>
              </div>
              <div className="item">
                <div className="boxColumn">
                  <button onClick={() => setActiveTab("PLANS")}>
                    {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          )}

          {user?.role === "companyManager" && (
            <div className="boxRow">
              <div className="item">
                <div className="boxColumn">
                  <label>{t("AVAILABLE_PART_CLASSES")}</label>
                </div>
              </div>

              <div className="item">
                <div className="boxColumn">
                  <div>
                    <label htmlFor={"activePLan"}>{t("CARD_PLAN")}</label>
                  </div>
                  <select
                    name="activePLan"
                    id="activePLan"
                    className="selectActivePlan"
                    value={activePlansSelected}
                    onChange={(e) => setActivePlansSelected(e.target.value)}
                  >
                    <option value="">{t("SELECT")}</option>
                    {activePlans.map((item) => (
                      <option key={item.id} value={item.id}>
                        {currentLanguage.language === "en"
                          ? item.plan.nameEnglish
                          : currentLanguage.language === "pt"
                          ? item.plan.namePortuguese
                          : item.plan.nameSpanish}{" "}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="item">
                <div className="boxColumn">
                  <div>
                    <label htmlFor={"numberClasses"}>{t("BTN_NUMBER_CLASSES")}</label>
                  </div>
                  <input
                    id="numberClasses"
                    className="inputNumberClasses"
                    placeholder={t("BTN_NUMBER_CLASSES")}
                    name="numberClasses"
                    value={numberClasses}
                    maxLength={2}
                    onChange={(e) => setNumberClasses(e.target.value)}
                  />
                </div>
              </div>

              <div className="item">
                <div className="boxColumn">
                  <button
                    className={activePlansSelected === "" || numberClasses === "" ? "" : "button-blue"}
                    disabled={activePlansSelected === "" || numberClasses === ""}
                    onClick={() => handleSubmitExtraClasses()}
                  >
                    {t("BTN_SAVE")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          )}

          {studentPlans && !studentPlans.plans && (
            <div className="boxRow boxColumn">{"Student hasn't finalized a subscription!"}</div>
          )}
        </DivSubscription>
      </StudentManagementCss>
    </div>
  );
}

export default StudentSubscription;
